import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import classes from '@nerdwallet/base-styles/classes';
import { Link, Text, Stack } from '@nerdwallet/currency';
import SocialMediaLinks from './social-media-links';

interface AuthorCardProps {
  name: string;
  heading: string;
  bio: string;
  fullPageUrl: string;
  socialMediaLinks: Array<{
    url: string;
    type: string;
  }>;
}

const AuthorCard = ({
  name,
  heading,
  bio,
  fullPageUrl,
  socialMediaLinks,
}: AuthorCardProps) => {
  if (!name) {
    return null;
  }

  return (
    <Stack spacing={1} className={classNames(['author-card'])}>
      <Text component="p" size="small">
        {heading && <Text bold>{heading} </Text>}
        {bio && (
          <Text className="author-card__bio">
            {bio}
            {fullPageUrl && (
              <Link
                href={fullPageUrl}
                className={classNames([classes(['nowrap'])])}
              >
                {' '}
                Read more
              </Link>
            )}
          </Text>
        )}
      </Text>
      <SocialMediaLinks mediaLinks={socialMediaLinks} authorName={name} />
    </Stack>
  );
};

AuthorCard.displayName = 'nw-author-card';

AuthorCard.propTypes = {
  name: PropTypes.string.isRequired,
  heading: PropTypes.string,
  bio: PropTypes.string,
  fullPageUrl: PropTypes.string,
  socialMediaLinks: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
    })
  ),
};

export default AuthorCard;
